export var SubstrateMessageType;
(function (SubstrateMessageType) {
    SubstrateMessageType["transfer_request"] = "transfer_request";
    SubstrateMessageType["sign_payload_request"] = "sign_payload_request";
})(SubstrateMessageType || (SubstrateMessageType = {}));
//# sourceMappingURL=message-type.js.map